// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(18, 42, 59, 0.54);
  backdrop-filter: blur(12px);
  animation: all-confirm-fade-in 0.2s ease-out;
}

.all-confirm-modal {
  position: relative;
  width: min(100%, 440px);
  overflow: hidden;
  padding: 28px;
  border: 1px solid rgba(78, 119, 153, 0.2);
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(19, 48, 69, 0.24), 0 1px 0 rgba(255, 255, 255, 0.9) inset;
  animation: all-confirm-enter 0.24s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.all-confirm-modal::before {
  position: absolute;
  top: 0;
  left: 28px;
  right: 28px;
  height: 3px;
  content: "";
  border-radius: 0 0 999px 999px;
  background: #e95a13;
}

.all-confirm-modal.danger::after {
  position: absolute;
  top: 22px;
  right: 24px;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  content: "!";
  color: #e95a13;
  border: 1px solid rgba(233, 90, 19, 0.25);
  border-radius: 9px;
  background: #fff5ef;
  font-size: 0.95rem;
  font-weight: 800;
}

.all-confirm-title {
  max-width: calc(100% - 42px);
  margin: 0 0 9px;
  color: #18344f;
  font-size: 1.18rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.all-confirm-message {
  margin: 0 0 25px;
  color: #607b91;
  font-size: 0.93rem;
  line-height: 1.55;
}

.all-confirm-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.all-btn-cancel,
.all-btn-confirm {
  min-height: 44px;
  padding: 10px 16px;
  border-radius: 11px;
  font-size: 0.86rem;
  font-weight: 750;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.all-btn-cancel {
  color: #55748e;
  border: 1px solid #d9e5ed;
  background: #f8fbfd;
}

.all-btn-cancel:hover {
  color: #18344f;
  border-color: #aac2d3;
  background: #eef5f9;
}

.all-btn-confirm,
.all-confirm-modal.danger .all-btn-confirm,
.all-btn-confirm.danger {
  color: #ffffff;
  border: 1px solid #e95a13;
  background: #e95a13;
  box-shadow: 0 10px 20px rgba(233, 90, 19, 0.2);
}

.all-btn-confirm:hover {
  border-color: #c94b0c;
  background: #c94b0c;
  box-shadow: 0 13px 24px rgba(233, 90, 19, 0.28);
  transform: translateY(-1px);
}

.all-btn-cancel:focus-visible,
.all-btn-confirm:focus-visible {
  outline: 3px solid rgba(78, 119, 153, 0.32);
  outline-offset: 2px;
}

@keyframes all-confirm-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes all-confirm-enter {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 480px) {
  .all-confirm-overlay {
    align-items: center;
    justify-content: center;
    padding:
      max(14px, env(safe-area-inset-top))
      14px
      max(14px, env(safe-area-inset-bottom));
  }

  .all-confirm-modal {
    width: 100%;
    max-height: calc(100dvh - 28px);
    overflow-y: auto;
    padding: 24px 20px 20px;
    border-radius: 18px;
  }

  .all-confirm-modal::before {
    left: 20px;
    right: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/reusable/ConfirmModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,sFAAsF;EACtF,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yGAAyG;AAC3G;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB;;;4CAGwC;EAC1C;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":[".all-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(18, 42, 59, 0.54);\n  backdrop-filter: blur(12px);\n  animation: all-confirm-fade-in 0.2s ease-out;\n}\n\n.all-confirm-modal {\n  position: relative;\n  width: min(100%, 440px);\n  overflow: hidden;\n  padding: 28px;\n  border: 1px solid rgba(78, 119, 153, 0.2);\n  border-radius: 20px;\n  background: #ffffff;\n  box-shadow: 0 24px 70px rgba(19, 48, 69, 0.24), 0 1px 0 rgba(255, 255, 255, 0.9) inset;\n  animation: all-confirm-enter 0.24s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.all-confirm-modal::before {\n  position: absolute;\n  top: 0;\n  left: 28px;\n  right: 28px;\n  height: 3px;\n  content: \"\";\n  border-radius: 0 0 999px 999px;\n  background: #e95a13;\n}\n\n.all-confirm-modal.danger::after {\n  position: absolute;\n  top: 22px;\n  right: 24px;\n  display: grid;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  content: \"!\";\n  color: #e95a13;\n  border: 1px solid rgba(233, 90, 19, 0.25);\n  border-radius: 9px;\n  background: #fff5ef;\n  font-size: 0.95rem;\n  font-weight: 800;\n}\n\n.all-confirm-title {\n  max-width: calc(100% - 42px);\n  margin: 0 0 9px;\n  color: #18344f;\n  font-size: 1.18rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.all-confirm-message {\n  margin: 0 0 25px;\n  color: #607b91;\n  font-size: 0.93rem;\n  line-height: 1.55;\n}\n\n.all-confirm-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.all-btn-cancel,\n.all-btn-confirm {\n  min-height: 44px;\n  padding: 10px 16px;\n  border-radius: 11px;\n  font-size: 0.86rem;\n  font-weight: 750;\n  cursor: pointer;\n  transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.all-btn-cancel {\n  color: #55748e;\n  border: 1px solid #d9e5ed;\n  background: #f8fbfd;\n}\n\n.all-btn-cancel:hover {\n  color: #18344f;\n  border-color: #aac2d3;\n  background: #eef5f9;\n}\n\n.all-btn-confirm,\n.all-confirm-modal.danger .all-btn-confirm,\n.all-btn-confirm.danger {\n  color: #ffffff;\n  border: 1px solid #e95a13;\n  background: #e95a13;\n  box-shadow: 0 10px 20px rgba(233, 90, 19, 0.2);\n}\n\n.all-btn-confirm:hover {\n  border-color: #c94b0c;\n  background: #c94b0c;\n  box-shadow: 0 13px 24px rgba(233, 90, 19, 0.28);\n  transform: translateY(-1px);\n}\n\n.all-btn-cancel:focus-visible,\n.all-btn-confirm:focus-visible {\n  outline: 3px solid rgba(78, 119, 153, 0.32);\n  outline-offset: 2px;\n}\n\n@keyframes all-confirm-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes all-confirm-enter {\n  from {\n    opacity: 0;\n    transform: translateY(14px) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 480px) {\n  .all-confirm-overlay {\n    align-items: center;\n    justify-content: center;\n    padding:\n      max(14px, env(safe-area-inset-top))\n      14px\n      max(14px, env(safe-area-inset-bottom));\n  }\n\n  .all-confirm-modal {\n    width: 100%;\n    max-height: calc(100dvh - 28px);\n    overflow-y: auto;\n    padding: 24px 20px 20px;\n    border-radius: 18px;\n  }\n\n  .all-confirm-modal::before {\n    left: 20px;\n    right: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
